import { Typography } from 'antd';
import { ContainerOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

type Props = {
    open: boolean;
    onClose: () => void;
    onUnarchive: () => void;
};

const UnarchiveJobModal = ({ open, onClose, onUnarchive }: Props) => {
    return (
        <ConfirmationModal
            open={open}
            icon={<ContainerOutlined />}
            title="Unarchive Job?"
            confirmButtonText="Unarchive"
            onConfirm={onUnarchive}
            onCancel={onClose}
            content={<Typography.Text>The job will be removed from the archive.</Typography.Text>}
        />
    );
};

export default UnarchiveJobModal;
